import award1 from '@/assets/images/award1.png'
import award2 from '@/assets/images/award2.png'
import award3 from '@/assets/images/award3.png'
import award4 from '@/assets/images/award4.png'
import image1 from '@/assets/images/ultrasound.png'
import image2 from '@/assets/images/xray.png'
import image3 from '@/assets/images/ecg.png'
import image4 from '@/assets/images/electrocardiogram.png'
import image5 from '@/assets/images/mammography.png'
import PFT from '@/assets/images/PFT.png'
import TMT from '@/assets/images/TMT.png'
import {
  ABOUT_US_PAGE,
  CONTACT_US_PAGE,
  FEEDBACK_PAGE,
  AGILUS_NEPAL_URL,
  AGILUS_NEAREST_LAB_URL,
  DDRC_AGILUS_URL,
  KEY_MEMBERS_PAGE,
  DOCTORS_PAGE,
  ONLINE_PAYMENT_MODE,
  OUR_INVESTORS_PAGE,
  PAY_DURING_COLLECTION_MODE,
  EDOS_PAGE,
  AGILUS_UNIVERSE_PAGE,
  CAREERS_PAGE,
  BLOG_PAGE,
  NEARBY_LABS_PAGE,
  SUBSIDIARY_CONFIG,
  BECOME_A_VENDOR_PAGE,
  PARTNER_WITH_US_PAGE,
  AGILUS_SITE_URL,
} from '@/utils/constants'
import PayNowIcon from '@/assets/icons/PayNow'
import PayDuringCollectionIcon from '@/assets/icons/PayDuringCollection'
import SqureBagIcon from '@/assets/icons/SqureBagIcon'
import SquareGrowthIcon from '@/assets/icons/SquareGrowthIcon'
import SquareWalletIcon from '@/assets/icons/SquareWalletIcon'
import SquareComputerIcon from '@/assets/icons/SquareComputerIcon'
import SquareGroupIcon from '@/assets/icons/SquareGroupIcon'
import HospitalIcon from '@/assets/icons/HospitalIcon'
import ClipboardIcon from '@/assets/icons/ClipboardIcon'
import GrowthIcon from '@/assets/icons/GrowthIcon'
import HeadphoneIcon from '@/assets/icons/HeadphoneIcon'
import TrendIcon from '@/assets/icons/TrendIcon'
import ComputerIcon from '@/assets/icons/ComputerIcon'
import TestTubeIcon from '@/assets/icons/TestTubeIcon'
import NavYouTubeIcon from '@/assets/icons/NavYouTubeIcon'
import NavInstagramIcon from '@/assets/icons/NavInstagramIcon'
import NavFacebookIcon from '@/assets/icons/NavFacebookIcon'
import NavLinkedInIcon from '@/assets/icons/NavLinkedInIcon'
import NavTwitterIcon from '@/assets/icons/NavTwitterIcon'
import BookViaWhatsAppIcon from '@/assets/icons/BookViaWhatsAppIcon'
import BookViaCallIcon from '@/assets/icons/BookViaCallIcon'
import UploadOrderIcon from '@/assets/icons/UploadOrderIcon'
import FindNearbyLabsIcon from '@/assets/icons/FindNearbyLabsIcon'

const {
  CUSTOMER_CARE_NUMBER,
  YOUTUBE_URL,
  TWITTER_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  COMPLIANCE_PORTAL_URL,
  EMPLOYEE_PORTAL_URL,
} = SUBSIDIARY_CONFIG

export const FEATURE_DATA = [
  {
    id: 'case1',
    title: 'Book via WhatsApp',
    description: 'Get instant replies',
    backgroundColor: 'bg-[#E2ECE6]',
    isLoginNeeded: false,
    icon: <BookViaWhatsAppIcon className="w-full h-full" />,
  },
  {
    id: 'case2',
    title: 'Book via Call',
    description: 'Talk to health advisor',
    backgroundColor: 'bg-[#DBF0FF]',
    isLoginNeeded: false,
    icon: <BookViaCallIcon className="w-full h-full" />,
  },
  {
    id: 'case3',
    title: 'Upload and Book',
    description: 'Get assistance from experts',
    backgroundColor: 'bg-[#F6ECDD]',
    isLoginNeeded: true,
    icon: <UploadOrderIcon className="w-full h-full" />,
  },
  {
    id: 'case4',
    title: 'Find Nearby Labs',
    description: 'Locate labs near you',
    backgroundColor: 'bg-[#EDE8FC]',
    isLoginNeeded: false,
    icon: <FindNearbyLabsIcon className="w-full h-full" />,
  },
]

export const FAQ_DATA = [
  {
    question:
      'What kinds of pathology testing services are offered by DDRC Agilus Diagnostics?',
    answer:
      'DDRC Agilus Diagnostics (formerly DDRC SRL Diagnostics) provides a wide range of pathology and radiology services, offering more than 3,600 routine and specialized diagnostic tests. Our test portfolio includes routine tests such as CBC (Complete Blood Count), CRP (C-Reactive Protein), Widal, thyroid function tests, diabetes screening, liver and kidney function tests, as well as comprehensive health check-up packages. We also offer advanced diagnostic services in molecular biology, genetics, immunology, and radiology, including MRI, CT scans, X-rays, and ultrasound examinations, along with specialized wellness packages.',
    isHTML: false,
  },
  {
    question: 'How much time does it usually take to receive my test results?',
    answer:
      'Routine test results at DDRC Agilus Diagnostics are generally available within 24 hours. However, the turnaround time may vary depending on the type of test performed and the specific laboratory location.',
  },
  {
    question: 'Is DDRC Agilus Diagnostics and DDRC SRL Diagnostics the same?',
    answer: `Yes, DDRC Agilus Diagnostics is the new name of DDRC SRL Diagnostics. The brand was renamed in 2023; however, our commitment to delivering reliable diagnostic services remains unchanged. We continue to offer the same high-quality standards, extensive laboratory network, and trusted diagnostic expertise that have been the foundation of our legacy.`,
    isHTML: false,
  },
  {
    question:
      'Is DDRC Agilus Diagnostics NABL accredited, and what measures do you take to ensure accurate test results?',
    answer:
      'Yes, DDRC Agilus Diagnostics is committed to maintaining the highest quality standards in diagnostic testing. We operate 4 NABL-accredited laboratories, 2 NABL (MELT)-accredited laboratories in Kerala, and 1 CAP-accredited laboratory in Mumbai. We ensure the accuracy of test results through rigorous quality control processes, skilled professionals, advanced technology, proper sample handling, and continuous staff training.',
    isHTML: false,
  },
  {
    question: `What are the lab's operating hours?`,
    answer: `DDRC Agilus Diagnostics labs typically operate from 6:30 AM to 6 PM on weekdays; however, hours may vary by location. To know the operating hours of a particular lab, kindly reach out to our customer support at ${CUSTOMER_CARE_NUMBER} by calling or connecting with us on WhatsApp.`,
    isHTML: false,
  },
  {
    question: 'How do I download an DDRC Agilus Diagnostics report?',
    answer: `<div><p>You can access your report by downloading it from our website or mobile app. Once your report is ready, it will also be shared with you via WhatsApp, SMS, and email for your convenience.</p>
    <p>Alternatively, you can contact our customer support team at ${CUSTOMER_CARE_NUMBER} by calling or connecting with us on WhatsApp for assistance.</p></div>`,
  },
  {
    question: `How can I contact DDRC Agilus Diagnostics?`,
    answer: `You can contact DDRC Agilus Diagnostics customer support at ${CUSTOMER_CARE_NUMBER} by giving us a call or connecting with us on WhatsApp for assistance with test bookings, home sample collection, report access, and general inquiries.`,
    isHTML: false,
  },
  {
    question: `Do your lab technicians have the required certifications?`,
    answer: `Yes, all laboratory technicians at DDRC Agilus Diagnostics hold certifications in laboratory technology from recognized universities or boards. They are trained to follow stringent quality protocols and best laboratory practices, helping ensure reliable diagnostic testing and accurate results.`,
  },
  {
    question: `What is the meaning of Upload Prescription?`,
    answer: `The Upload Prescription feature allows you to conveniently submit your doctor's prescription through the DDRC Agilus Diagnostics website or mobile app. Once your prescription is uploaded, our team will review the test requirements and contact you to assist with scheduling the recommended diagnostic tests. This feature simplifies the booking process and helps ensure that the tests prescribed by your healthcare practitioner are accurately scheduled.`,
    isHTML: false,
  },
  {
    question: `How does Home Sample Collection work?`,
    answer: `<div>
            <p class="text-label-lg leading-6 text-gray-700 mb-4">
              Home sample collection at DDRC Agilus Diagnostics follows a simple 4-step process:
            </p>
            <ol class="space-y-4">
              <li class="text-label-lg leading-6 text-gray-700">
                <strong class="text-gray-800">Step 1 </strong>– Order Completion: <br /> Select your tests and preferred time slot or upload your prescription through our website or mobile app. You can also book your tests by calling or connecting with us on WhatsApp at ${CUSTOMER_CARE_NUMBER}.
              </li>
              <li class="text-label-lg leading-6 text-gray-700">
                <strong class="text-gray-800">Step 2 </strong>– Safe Home
                Sample Collection: <br /> An expert phlebotomist visits your home to collect the required samples conveniently and safely.
              </li>
              <li class="text-label-lg leading-6 text-gray-700">
                <strong class="text-gray-800">Step 3 </strong>– Sample
                Delivery to the Laboratory: <br /> The collected samples are securely transported to our laboratory for testing and analysis.
              </li>
              <li class="text-label-lg leading-6 text-gray-700">
                <strong class="text-gray-800">Step 4 </strong>– Online
                Report Delivery: <br /> Once ready, your reports are delivered via WhatsApp, SMS, and email for easy access.
              </li>
            </ol>
          </div>`,
  },
  {
    question: `What is a preventive health checkup?`,
    answer: `<div><p>A preventive health checkup is a comprehensive evaluation of your health designed to identify potential medical conditions at an early stage, often before symptoms appear. It typically includes a combination of diagnostic tests and screenings to assess overall health, detect risk factors, and support timely medical intervention.</p>
    <p>At DDRC Agilus Diagnostics, our Packages offer a comprehensive range of full body health checkups designed to help you monitor your health, identify potential concerns, and take proactive steps towards disease prevention and long-term well-being.</p></div>`,
  },
  {
    question: `What kinds of Radiology testing services are offered by DDRC Agilus Diagnostics?`,
    answer: `At DDRC Agilus Diagnostics, we offer a wide range of radiology and diagnostic imaging services, including MRI scans, CT scans, X-rays, ultrasound scans, mammography, and Doppler studies. Our advanced imaging technology and experienced radiologists help ensure accurate diagnosis, timely reporting, and effective treatment planning. You can book a radiology test at ${CUSTOMER_CARE_NUMBER} by calling us or connecting with us on WhatsApp.`,
  },
]

export const FOOTER_DATA = [
  {
    name: 'Company',
    linksWithImage: false,
    content: [
      {
        name: 'About us',
        link: ABOUT_US_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Key members',
        link: KEY_MEMBERS_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Doctors',
        link: DOCTORS_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Contact us',
        link: CONTACT_US_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Agilus Diagnostics',
        link: AGILUS_SITE_URL,
        external: true,
        description: '',
      },
      {
        name: 'Agilus Nepal',
        link: AGILUS_NEPAL_URL,
        external: true,
        description: '',
      },
      {
        name: 'Agilus Universe',
        link: AGILUS_UNIVERSE_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Careers',
        link: CAREERS_PAGE,
        external: false,
        description: '',
      },
    ],
  },
  {
    name: 'Patients',
    linksWithImage: false,
    content: [
      {
        name: 'Upload Prescription',
        link: '/',
        external: false,
        description: '',
      },
      {
        name: 'Request a callback',
        link: '/',
        external: false,
        description: '',
      },
      {
        name: 'DDRC Agilus care packages',
        link: '/#agilus-care-package',
        external: false,
        description: '',
      },
      {
        name: 'Feedback',
        link: FEEDBACK_PAGE,
        external: false,
        description: '',
      },
      // {
      //   name: 'Blog',
      //   link: BLOG_PAGE,
      //   external: false,
      //   description: '',
      // },
      {
        name: 'Nearby labs',
        link: NEARBY_LABS_PAGE,
        external: false,
        description: '',
      },
    ],
  },
  {
    name: 'Partnership',
    linksWithImage: false,
    content: [
      {
        name: 'Partner with us',
        link: PARTNER_WITH_US_PAGE,
        external: false,
        description: '',
      },
      {
        name: 'Become a vendor',
        link: BECOME_A_VENDOR_PAGE,
        external: false,
        description: '',
      },
      // {
      //   name: 'Corporate tie-up',
      //   link: '',
      //   external: false,
      // },
      // {
      //   name: 'International partnership',
      //   link: '',
      //   external: false,
      // },
    ],
  },
  {
    name: 'Others',
    linksWithImage: false,
    content: [
      // {
      //   name: 'Employee portal',
      //   link: EMPLOYEE_PORTAL_URL,
      //   external: true,
      //   description: '',
      // },
      {
        name: 'eDOS (Test menu)',
        link: EDOS_PAGE,
        external: false,
        description: '',
      },
      // {
      //   name: 'Compliance portal',
      //   link: COMPLIANCE_PORTAL_URL,
      //   external: true,
      //   description: '',
      // },
      {
        name: 'Investor information',
        link: OUR_INVESTORS_PAGE,
        external: false,
        description: '',
      },
    ],
  },
  {
    name: 'Follow us',
    linksWithImage: true,
    content: [
      {
        name: 'FooterYoutubeIcon',
        link: YOUTUBE_URL,
        external: true,
        description: '',
      },
      {
        name: 'FooterInstagramIcon',
        link: INSTAGRAM_URL,
        external: true,
        description: '',
      },
      {
        name: 'FooterFacebookIcon',
        link: FACEBOOK_URL,
        external: true,
        description: '',
      },
      {
        name: 'FooterLinkedInIcon',
        link: LINKEDIN_URL,
        external: true,
        description: '',
      },
      {
        name: 'FooterTwitterIcon',
        link: TWITTER_URL,
        external: true,
        description: '',
      },
    ],
  },
  {
    name: 'Download the DDRC Agilus app',
    linksWithImage: true,
    content: [],
  },
]

export const IMAGING_TEST_DATA = [
  { id: 1, name: 'X-Ray', description: 'Starting @ ₹300', image: image2 },
  { id: 2, name: 'Ultrasound', description: 'Starting @ ₹500', image: image1 },
  { id: 3, name: 'ECG', description: 'Starting @ ₹200', image: image3 },
  { id: 4, name: 'TMT', description: 'Starting @ ₹200', image: TMT },
  {
    id: 5,
    name: 'Echocardiogram',
    description: 'Starting @ ₹149',
    image: image4,
  },
  {
    id: 6,
    name: 'PFT',
    description: 'Starting @ ₹1500',
    image: PFT,
  },
  {
    id: 7,
    name: 'Mammography',
    description: 'Starting @ ₹1500',
    image: image5,
  },
]

export const paymentMethods = [
  {
    description: 'UPI / Credit card / debit card / Net Banking',
    name: 'Pay now',
    type: ONLINE_PAYMENT_MODE,
    uuid: '',
    icon: <PayNowIcon className="max-w-[50px] w-full max-h-[50px] h-full" />,
  },
  {
    description: 'Pay in cash or pay online',
    name: 'Pay during collection',
    type: PAY_DURING_COLLECTION_MODE,
    uuid: '',
    icon: (
      <PayDuringCollectionIcon className="max-w-[50px] w-full max-h-[50px] h-full" />
    ),
  },
]

export const addressData = [
  {
    addressTag: 'DDRC Agilus Diagnostics - Corporate Office, Kaloor, Kochi',
    address:
      'Door No 65/621 A, Second Floor, Express House, Opp. Pothys Silks, Banarjee Road, Kaloor - 682017',
    phoneNumber: '9333493334',
  },
  {
    addressTag:
      'DDRC Agilus Diagnostics Registered Office - Mumbai, Maharashtra',
    address:
      '4th Floor, Prime Square, Plot No.1, Gaiwadi Industrial Estate, S.V.Road, Goregaon (West), Mumbai, Maharashtra 400062',
    phoneNumber: '',
  },
  // {
  //   addressTag: 'Agilus Diagnostics Corporate Office - New Delhi',
  //   address: '13, Palam Marg, Vasant Vihar, New Delhi 110057',
  //   phoneNumber: '011-41038152',
  // },
  // {
  //   addressTag: 'Agilus Diagnostics Registered Office - Mohali, Punjab',
  //   address: 'Fortis Hospital, Sector62, Phase - VIII, Mohali, Pin-160062',
  //   phoneNumber: '011-41038152',
  // },
]

export const AGILUS_STATS_DATA = [
  { title: '17', description: `Regional labs` },
  { title: '02', description: `State Reference <br/> Laboratories` },
  { title: '28', description: `Radiology/wellness <br/> Centers` },
  { title: '06', description: `NABL/NABL (MELT) <br/> Accredited Labs` },
]

export const DDRC_STATS_DATA = [
  { title: '1 Cr', description: `Tests Performed` },
  { title: '380 +', description: `Diagnostics Centres` },
  { title: '17', description: `Regional labs` },
  { title: '28', description: `Radiology/wellness <br/> Centers` },
]

export const IDIAL_AGILUS_PARTNER_DATA = [
  { label: 'Demonstrates a genuine interest in the healthcare sector.' },
  {
    label:
      'Owns or rents a space in a medically active area or a premium residential location.',
  },
  {
    label:
      'Prepared to invest an additional 1-1.5 lakh rupees, aside from infrastructure costs.',
  },
  {
    label:
      'Capable of dedicating a significant amount of time to the business.',
  },
  { label: 'Committed to establishing a long-term business partnership.' },
]

export const HOW_AGILUS_SUPPORT_YOU_DATA_FIRST = [
  {
    label: 'Assistance with the setup of the collection center.',
    icon: <HospitalIcon className="mb-4 flex mx-auto" />,
  },
  {
    label: 'Sample pickup services and online report generation.',
    icon: <ClipboardIcon className="mb-4 flex mx-auto" />,
  },
  {
    label: 'Support for brand development and initiatives.',
    icon: <GrowthIcon className="mb-4 flex mx-auto" />,
  },
  {
    label:
      'Access to a dedicated call center for addressing operational issues. ',
    icon: <HeadphoneIcon className="mb-4 flex mx-auto" />,
  },
]

export const HOW_AGILUS_SUPPORT_YOU_DATA_SECOND = [
  {
    label:
      'Supply of consumables like vacutainers, urine containers, and essentials.',
    icon: <TestTubeIcon className="mb-4 flex mx-auto" />,
  },
  {
    label: 'Expert guidance in technical operations and lab management.',
    icon: <TrendIcon className="mb-4 flex mx-auto" />,
  },
  {
    label: 'Comprehensive training and transfer of domain expertise.',
    icon: <ComputerIcon className="mb-4 flex mx-auto" />,
  },
]

export const SOCIAL_LINK_DATA = [
  { key: 'YouTube', icon: <NavYouTubeIcon />, link: YOUTUBE_URL },
  { key: 'Instagram', icon: <NavInstagramIcon />, link: INSTAGRAM_URL },
  { key: 'Facebook', icon: <NavFacebookIcon />, link: FACEBOOK_URL },
  { key: 'LinkedIn', icon: <NavLinkedInIcon />, link: LINKEDIN_URL },
  { key: 'Twitter', icon: <NavTwitterIcon />, link: TWITTER_URL },
]

export const WHY_CHOOSE_AGILUS_DATA = [
  {
    icon: <SqureBagIcon />,
    title: 'Work as an Entrepreneur',
    subtitle: 'Take charge of your business with comprehensive support. ',
  },
  {
    icon: <SquareGrowthIcon />,
    title: 'Freedom and Flexibility',
    subtitle: 'Operate independently while maintaining a work-life balance.',
  },
  {
    icon: <SquareWalletIcon />,
    title: 'Low Investment',
    subtitle: 'Benefit from a low-cost investment and a proven business model.',
  },
  {
    icon: <SquareComputerIcon />,
    title: 'Technical & Lab Support',
    subtitle:
      'Receive expert guidance and assistance to ensure operational efficiency.',
  },
  {
    icon: <SquareGroupIcon />,
    title: 'Business Growth',
    subtitle:
      'Leverage the Agilus brand to foster business expansion and profitability.',
  },
]

export const CONTACT_PURPOSE_LISTING = [
  {
    label: 'Become a partner',
    value: 'BECOME_A_PARTNER',
  },
  {
    label: 'Call back request',
    value: 'CALL_BACK_REQUEST',
  },
  {
    label: 'Corporate tie up',
    value: 'CORPORATE_TIE_UP',
  },
  {
    label: 'Duplicate ID delete request',
    value: 'DUPLICATE_ID_DELETE_REQUEST',
  },
  {
    label: 'Feedback',
    value: 'FEEDBACK',
  },
  {
    label: 'Home visit enquiry',
    value: 'HOME_VISIT_ENQUIRY',
  },
  {
    label: 'Test enquiry',
    value: 'TEST_ENQUIRY',
  },
  {
    label: 'Request to resend the report',
    value: 'REQUEST_TO_RESEND_THE_REPORT',
  },
]

export const BECOME_PARTNER_OWNERSHIP_DATA = [
  { label: 'Individual', value: 'INDIVIDUAL' },
  { label: 'Huf', value: 'HUF' },
  { label: 'Partnership/Firm', value: 'PARTNERSHIP/FIRM' },
]

export const BECOME_PARTNER_BUSINESS_PROFESSION_DATA = [
  { label: 'Technician', value: 'TECHNICIAN' },
  { label: 'Phlebotomist', value: 'PHLEBOTOMIST' },
  { label: 'Doctor', value: 'DOCTOR' },
  { label: 'Businessman', value: 'BUSINESSMAN' },
  { label: 'Other', value: 'OTHER' },
]

export const BECOME_PARTNER_ASSOCIATION_WITH_AGILUS_DATA = [
  { label: 'Business Partnership', value: 'BUSINESS_PARTNERSHIP' },
  { label: 'Supplier', value: 'SUPPLIER' },
  { label: 'None', value: 'NONE' },
]

export const STATE_REGION_MAP = {
  'andhra pradesh': 'IN-AP',
  'arunachal pradesh': 'IN-AR',
  assam: 'IN-AS',
  bihar: 'IN-BR',
  chhattisgarh: 'IN-CT',
  goa: 'IN-GA',
  gujarat: 'IN-GJ',
  haryana: 'IN-HR',
  'himachal pradesh': 'IN-HP',
  jharkhand: 'IN-JH',
  karnataka: 'IN-KA',
  kerala: 'IN-KL',
  'madhya pradesh': 'IN-MP',
  maharashtra: 'IN-MH',
  manipur: 'IN-MN',
  meghalaya: 'IN-ML',
  mizoram: 'IN-MZ',
  nagaland: 'IN-NL',
  odisha: 'IN-OR',
  punjab: 'IN-PB',
  rajasthan: 'IN-RJ',
  sikkim: 'IN-SK',
  'tamil nadu': 'IN-TN',
  telangana: 'IN-TG',
  tripura: 'IN-TR',
  'uttar pradesh': 'IN-UP',
  uttarakhand: 'IN-UT',
  'west bengal': 'IN-WB',
  'andaman and nicobar islands': 'IN-AN',
  chandigarh: 'IN-CH',
  'dadra and nagar haveli and daman and diu': 'IN-DH',
  delhi: 'IN-DL',
  'new delhi': 'IN-DL',
  'jammu and kashmir': 'IN-JK',
  ladakh: 'IN-LA',
  lakshadweep: 'IN-LD',
  puducherry: 'IN-PY',
}

export const AGILUS_AWARDS_DATA = [
  {
    img: award1,
    year: '2024',
    text: 'Best Diagnostics Chain Of The Year at the HealthMeet & Excellence Awards by ASSOCHAM',
  },
  {
    img: award2,
    year: '2023',
    text: 'GOLD Award in Patient Centric Diagnostic Lab Category',
  },
  {
    img: award3,
    year: '2023',
    text: 'Anand K - Leading Healthcare CEO Of The Year at eHealth & Summit Awards',
  },
  {
    img: award4,
    year: '2023',
    text: 'National Diagnostics Chain Of The Year by The Economic Times Healthcare Awards',
  },
]

// Health-checkup city page descriptive content. "$" is replaced with the city name at render time.
export const HEALTH_CHECKUP_DESCRIPTION_HTML = `
<p>Take control of your health with reliable blood testing services and comprehensive full body health checkup packages in $. At Agilus Diagnostics, we offer a wide range of diagnostic tests, convenient sample collection and online access to reports, making healthcare easier and more accessible.</p><p>Our diagnostic services include routine blood tests, specialised diagnostic tests and preventive health checkup packages to support your healthcare needs.</p><h2>Why Choose Agilus Diagnostics?</h2><ul><li><p><strong>Wide Range of Diagnostic Tests:</strong> Access routine blood tests and specialised diagnostic tests to meet different testing requirements.</p></li><li><p><strong>Advanced Laboratory Technology:</strong> Modern laboratory technology supports accuracy and precision in diagnostic testing.</p></li><li><p><strong>Trained Professionals and Certified Laboratories:</strong> Testing services are supported by trained professionals and certified laboratories.</p></li><li><p><strong>Quality Control Measures:</strong> Established quality control processes help support reliable test results.</p></li><li><p><strong>Convenient Testing Options:</strong> Explore available testing services, online reports and home sample collection where available.</p></li></ul><h2>Blood Test in $: Convenient Diagnostic Testing</h2><p>A blood test in $ can help detect infections, nutritional deficiencies, organ function issues and chronic conditions. Whether you need routine health screening or a doctor-recommended investigation, timely blood testing can provide important information about your health.</p><p>Blood tests are an important part of healthcare. They can help identify potential health concerns, monitor existing conditions and support your doctor in making informed decisions about your care.</p><h3>What Can Blood Tests Help With?</h3><h4><strong>Early Disease Detection</strong></h4><p>Blood tests can help detect certain health conditions before noticeable symptoms appear, depending on the condition and the test performed.</p><h4><strong>Infection Diagnosis</strong></h4><p>Blood tests can help identify infections and support diagnosis when considered alongside symptoms and other clinical findings.</p><h4><strong>Nutritional Assessment</strong></h4><p>Blood tests can help identify nutritional deficiencies, including certain vitamin and mineral deficiencies.</p><h4><strong>Organ Function Evaluation</strong></h4><p>Blood tests can help assess the functioning of organs such as the liver and kidneys.</p><h4><strong>Chronic Disease Management</strong></h4><p>Regular testing can help monitor chronic conditions and track changes in health over time.</p><h2>Blood Test at Home in $</h2><p>With Agilus Diagnostics' blood test at home service, you can arrange for sample collection at your doorstep without travelling to a laboratory. Book a home sample collection appointment at an available time and get your samples collected by trained professionals.</p><h3>Benefits of Blood Test at Home</h3><p><strong>Easy Online Booking:</strong> Book home sample collection online at a convenient available time.</p><p><strong>Trained Phlebotomists:</strong> Have your blood samples collected by trained phlebotomists.</p><p><strong>Safe and Hygienic Sample Collection:</strong> Sample collection follows established hygiene and safety procedures.</p><p><strong>Timely Digital Reports:</strong> Access your reports online once they are available.</p><p>Home sample collection can be particularly convenient for senior citizens, working professionals, families and patients who require regular monitoring. Availability may vary by location.</p><h2>Blood Test Normal Values and Reference Ranges</h2><p>Understanding blood test normal values can help you read your laboratory report. Each test may have a reference range indicating the values generally expected for that test. These ranges can vary depending on factors such as age, sex and laboratory methods.</p><h3>Why Are Blood Test Reference Ranges Important?</h3><p><strong>Understanding Health Indicators:</strong> Reference ranges help you compare your test results with the expected range for a particular test.</p><p><strong>Identifying Potential Concerns:</strong> Results outside the reference range may indicate a potential health concern and may require further evaluation.</p><p><strong>Tracking Changes Over Time:</strong> Comparing test results across different dates can help monitor changes in your health.</p><p><strong>Supporting Preventive Care:</strong> Test results can help your doctor recommend appropriate follow-up, further testing or lifestyle changes when needed.</p><p>A result outside the reference range does not always indicate a medical condition. Similarly, a result within the reference range does not rule out every health problem. Always consult your doctor to understand your results in the context of your medical history, symptoms and overall health.</p><h2>Blood Test Price in $</h2><p>Looking for blood test prices in $? At Agilus Diagnostics, you can explore available blood tests and check their applicable prices before booking.</p><p>The blood test price depends on the type of test you need. Review the applicable price and test details online before confirming your booking to make an informed choice.</p><h2>Full Body Checkup in $: Comprehensive Preventive Screening</h2><p>A full body checkup in $ combines selected diagnostic tests to provide a broader assessment of your health. It can help identify potential health concerns and support preventive healthcare.</p><p>Regular health checkups, based on your age, medical history and risk factors, can help you and your doctor make informed decisions about your healthcare needs.</p><h3>Benefits of a Full Body Health Checkup</h3><h4><strong>Early Risk Identification</strong></h4><p>Screening can help identify certain health conditions and risk factors before noticeable symptoms appear. Timely evaluation can help your doctor determine whether further investigation or intervention is needed.</p><h4><strong>Assessment of Key Health Indicators</strong></h4><p>A full body health checkup provides an overview of selected health indicators through the tests included in the package. Depending on the package, these tests may assess heart health indicators, liver function, kidney function and thyroid function.</p><h4><strong>Support for Timely Medical Intervention</strong></h4><p>Identifying certain health conditions early can help doctors plan appropriate follow-up and treatment when required.</p><h4><strong>Long-Term Health Monitoring</strong></h4><p>Regular health monitoring can help track changes in your health and support preventive care based on your individual needs.</p><p>The tests included in a full body checkup vary by package. Your doctor can help you choose the tests most appropriate for your age, medical history and health requirements.</p><h2>Full Body Checkup Price in $</h2><p>Looking for a full body checkup at a price that suits your budget? Agilus Diagnostics offers different health checkup packages to address varying testing and screening needs.</p><p>The full body checkup price depends on the package selected and the tests included. Explore the available packages, compare their test parameters and check the applicable price before booking.</p><h2>Full Body Health Checkup Packages in $</h2><p>Agilus Diagnostics offers complete body health checkup packages for people with different health and screening needs. Choosing an appropriate package depends on your age, medical history, risk factors and doctor's recommendations.</p><p>Our packages may be suitable for:</p><ul><li><p><strong>Men and Women:</strong> Explore health screening options based on individual health needs and medical advice.</p></li><li><p><strong>Senior Citizens:</strong> Monitor important health indicators based on age, medical history and your doctor's recommendations.</p></li><li><p><strong>Working Professionals:</strong> Make time for health screening with convenient testing and home sample collection options where available.</p></li><li><p><strong>Preventive Annual Screening:</strong> Keep track of your health through regular screening based on your age, risk factors and medical advice.</p></li></ul><h3>Benefits of Home Sample Collection</h3><p><strong>Doorstep Convenience:</strong> Get your samples collected at home without travelling to a laboratory.</p><p><strong>Flexible Scheduling:</strong> Choose from available sample collection time slots that fit your daily routine.</p><p><strong>Safe and Hygienic Process:</strong> Trained professionals follow established sample collection and hygiene procedures.</p><p><strong>Convenience for Different Needs:</strong> Home sample collection can be particularly helpful for senior citizens, working professionals, families and patients who require regular health monitoring.</p><h2>Why Choose Agilus Diagnostics for Blood Tests and Health Checkups?</h2><p>Agilus Diagnostics offers a wide range of diagnostic services to help you stay informed about your health.</p><ul><li><p><strong>Diagnostic Network Across India:</strong> Access diagnostic services through our network of centres.</p></li><li><p><strong>Advanced Laboratory Infrastructure:</strong> Modern laboratory facilities support diagnostic testing.</p></li><li><p><strong>Quality-Focused Testing Processes:</strong> Established testing procedures and quality control measures help support reliable results.</p></li><li><p><strong>Home Sample Collection:</strong> Arrange sample collection at home at locations where the service is available.</p></li><li><p><strong>Secure Online Access to Reports:</strong> View your reports online once they are available.</p></li></ul><h2>Book Your Blood Test or Full Body Health Checkup in $</h2><p>Take a proactive step towards understanding your health with Agilus Diagnostics. Explore available blood tests, compare whole body health checkup packages and arrange home sample collection at your convenience.</p><p><strong>Book your blood test or complete body health checkup with Agilus Diagnostics today. Your health deserves timely attention and care.</strong></p><p></p>`
